import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const URL = "https://puntosurgdl.com/backend/"

// export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
// export const LOGIN_URL = `${API_URL}/login`
// export const REGISTER_URL = `${API_URL}/register`
// export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

export const GET_USER_BY_ACCESSTOKEN_URL = 'https://puntosurgdl.com/backend/verify_token.php'
export const LOGIN_URL = 'https://puntosurgdl.com/backend/login.php'
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = 'https://puntosurgdl.com/backend/passwordResetToken.php'
export const UPDATE_PASSWORD_URL = 'https://puntosurgdl.com/backend/updatePassword.php'
export const VALIDATE_RESET_TOKEN = 'https://puntosurgdl.com/backend/validateResetToken.php'

// Server should return AuthModel
export function login(email: string, pass: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    pass,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function updatePass(email: string | null | undefined, pass: string) {
  return axios.post<{result: boolean}>(UPDATE_PASSWORD_URL, {
    email,
    pass,
  })
}

export function validateResetToken(key: string, token: string) {
  return axios.post<{result: boolean}>(VALIDATE_RESET_TOKEN, {
    key,
    token
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
